import { useEffect, useState } from 'react';
import { BrowserRouter as Router, useHistory } from 'react-router-dom';
import { CachePolicies, Provider as FetchProvider } from 'use-http';
import { CartProvider } from '../context/CartContext';
import { SettingsProvider } from '../context/SettingsContext';
import { TransferProvider } from '../context/TransferContext';
import { UserProvider } from '../context/UserContext';
import RouterFbClick from '../hooks/routerFbClick';
import useToken from '../hooks/useToken';
import CookiesConsent from '../shared/CookiesConsent';
import ErrorModal from '../shared/ErrorModal';
import GoogleAnalytics from '../shared/GoogleAnalytics';
import Header from '../shared/Header';
import PaymentRedirectModal from '../shared/PaymentRedirectModal';
import ScrollToTop from '../shared/ScrollToTop';
import TimeSlotSession from '../shared/TimeSlotSession';
import IdleTimerContainer from './IdleTimerContainer';
import PopUp from '../hooks/popUp';
import GoogleAnalyticsTag from '../shared/GoogleAnalyticsTag/GoogleAnalyticsTag';
import { PrimeReactProvider } from 'primereact/api';
import Footer from '../shared/Footer';
import ErrorBoundary from '../shared/ErrorBoundry/ErrorBoundary.js';
import AppRoutes from './AppRoutes';
import GenesysWrapper from '../hooks/genesysWrapper.js';
import Body from './Body';
import HeaderNav from '../shared/Header/HeaderNav';
import { CartDataProvider } from '@/v2/pages/CartPage/context/CartDataContext';
import { RegistrationProvider } from '@/v2/pages/CartPage/context/RegistrationContext';
import PathnameBridge from '@/v2/pages/CartPage/context/PathnameBridge';
import GlobalDialogListener from '../hooks/globalDialogListener';
import { SessionProvider } from '../context/SessionContext/SessionContext';

function App() {
  const { handleToken } = useToken();
  const [showError] = useState(false); // setShowError
  const history = useHistory();
  const [showHeaders, setShowHeaders] = useState(true);
  const pathname = window.location.pathname;
  useEffect(() => {
    if (pathname.includes('/widget')) {
      setShowHeaders(false);
    }
  }, [history, pathname]);

  useEffect(() => {
    window.exponeaToken = process.env.REACT_APP_EXPONEA;
    // eslint-disable-next-line no-undef
    initializeScript();
  }, []);

  const value = {
    ripple: true,
  };

  return (
    <PrimeReactProvider value={value}>
      <FetchProvider
        url={process.env.REACT_APP_API_BASE}
        options={{
          cachePolicy: CachePolicies.NO_CACHE,
          headers: {
            'Access-Control-Allow-Origin': `${process.env.REACT_APP_BASE_ADDRESS}`,
          },
          interceptors: {
            request: async ({ options }) => {
              const token = await handleToken();
              options.headers.Authorization = `Bearer ${token}`;
              return options;
            },
          },
        }}
      >
        <UserProvider>
          <SettingsProvider>
            <CartProvider>
              <TransferProvider>
                <GenesysWrapper>
                  <CartDataProvider>
                    <SessionProvider>
                      <Router>
                        <PathnameBridge />
                        <RegistrationProvider>
                          <RouterFbClick />
                          <PopUp />
                          <ScrollToTop />
                          {/* <Header show={showHeaders}>
                          <div
                            style={{
                              color: '#333',
                              backgroundColor: '#f3f3f3',
                              padding: 20,
                              borderRadius: 16,
                              marginLeft: 20,
                              fontSize: 12,
                              maxWidth: 300,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          ></div>
                        </Header> */}
                          <HeaderNav />
                          <Body>
                            <TimeSlotSession />
                            <GlobalDialogListener />
                            <IdleTimerContainer>
                              <ErrorBoundary>
                                <AppRoutes />
                              </ErrorBoundary>
                            </IdleTimerContainer>
                            <PaymentRedirectModal />
                          </Body>
                          <Footer show={showHeaders} />
                        </RegistrationProvider>
                      </Router>
                    </SessionProvider>
                  </CartDataProvider>
                  <ErrorModal showError={showError} />
                  <CookiesConsent />
                </GenesysWrapper>
              </TransferProvider>
            </CartProvider>
          </SettingsProvider>
        </UserProvider>
      </FetchProvider>
    </PrimeReactProvider>
  );
}

export default App;
